import { render, staticRenderFns } from "./payment_sale_information.vue?vue&type=template&id=4b503995&"
import script from "./payment_sale_information.vue?vue&type=script&lang=js&"
export * from "./payment_sale_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports